import { withTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";
import VideoManageBase from "./VideoManageBase";

class CreateVideo extends VideoManageBase {}

export default withRouter(withTranslation()(CreateVideo));
